import React from "react";
import { useNavigate, Link } from "react-router-dom";
import SEOHead from "../components/SEOHead";
import { getAuth } from "firebase/auth";

function ResumeMistakes() {
  const navigate = useNavigate();
  const auth = getAuth();

  const handleStart = () => {
    if (auth.currentUser) {
      navigate("/");
    } else {
      navigate("/get-started");
    }
  };

  return (
    <div style={{ padding: "40px", maxWidth: "900px", margin: "0 auto" }}>

      <SEOHead
        title="Resume Mistakes to Avoid (2026 Guide)"
        description="Avoid the most common resume mistakes that cost you interviews. Learn what recruiters hate and how to fix your resume with EmployPilot."
        canonical="https://employpilot.com/resume-mistakes"
      />

      <h1>Top Resume Mistakes to Avoid in 2026</h1>

      <p style={{ fontSize: "18px", color: "#555" }}>
        Even small resume mistakes can cost you interviews. Recruiters scan resumes quickly,
        and the wrong formatting, wording, or structure can get you rejected instantly.
      </p>

      <p style={{ fontWeight: "bold", marginTop: "15px" }}>
        Fixing just a few key mistakes can dramatically increase your chances of getting hired.
      </p>

      <button onClick={handleStart} style={btnPrimary}>
        Fix My Resume Now
      </button>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>Most Common Resume Mistakes</h2>

      <ul>
        <li>❌ Too much text and long paragraphs</li>
        <li>❌ No clear structure or formatting</li>
        <li>❌ Using outdated resume styles</li>
        <li>❌ Not tailoring your resume to the job</li>
        <li>❌ Listing responsibilities instead of achievements</li>
      </ul>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>Why These Mistakes Hurt You</h2>

      <p>
        Recruiters spend only a few seconds reviewing each resume. If your resume is difficult
        to read or doesn’t highlight your value quickly, it will likely be skipped.
      </p>

      <ul>
        <li>✔ Poor formatting reduces readability</li>
        <li>✔ Weak wording lowers impact</li>
        <li>✔ Generic resumes don’t stand out</li>
      </ul>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>How to Fix Your Resume</h2>

      <ol>
        <li>Use a clean, modern format</li>
        <li>Focus on measurable achievements</li>
        <li>Keep it concise and easy to scan</li>
        <li>Customize it for each job application</li>
      </ol>

      {/* 🔥 INTERNAL LINKS */}
      <p style={{ marginTop: "20px" }}>
        Need a better structure?{" "}
        <Link to="/best-resume-format">
          Learn the best resume format
        </Link>
      </p>

      <p>
        Want AI to fix it instantly?{" "}
        <Link to="/ai-resume-builder">
          Use our AI Resume Builder
        </Link>
      </p>

      {/* CTA */}
      <div style={{ marginTop: "50px", textAlign: "center" }}>
        <h2>Stop Losing Opportunities</h2>

        <button onClick={handleStart} style={btnSuccess}>
          Improve My Resume
        </button>
      </div>

      {/* FAQ SECTION */}
      <h2 style={{ marginTop: "60px" }}>
        Frequently Asked Questions
      </h2>

      <h3>What is the biggest resume mistake?</h3>
      <p>
        The biggest mistake is not clearly showing your value. Recruiters want to see results,
        not just job duties.
      </p>

      <h3>Do resume mistakes really matter?</h3>
      <p>
        Yes. Even small issues can cause recruiters to skip your resume in seconds.
      </p>

      <h3>Can AI fix my resume?</h3>
      <p>
        Yes. AI tools like EmployPilot can quickly improve structure, wording, and clarity.
      </p>
<div
    style={{
      marginTop: "80px",
      textAlign: "center",
      fontSize: "14px",
      color: "#777",
      borderTop: "1px solid #eee",
      paddingTop: "30px"
    }}
  >
    © 2026 EmployPilot. All Rights Reserved.

    <div style={{ marginTop: "10px" }}>
      <a href="/terms" style={{ margin: "0 10px" }}>
        Terms of Use
      </a>

      <a href="/privacy" style={{ margin: "0 10px" }}>
        Privacy Policy
      </a>

      <a href="/contact" style={{ margin: "0 10px" }}>
        Contact
      </a>
    </div>
  </div>
</div>
  );
}

const btnPrimary = {
  backgroundColor: "#007bff",
  color: "#fff",
  padding: "12px 20px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer",
  marginTop: "20px"
};

const btnSuccess = {
  backgroundColor: "#28a745",
  color: "#fff",
  padding: "14px 24px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer"
};

export default ResumeMistakes;